
export function search (idKey, prop, myArray) {
  for (var i = 0; i < myArray.length; i++) {
    if (myArray[i][prop] === idKey) {
      return i
    }
  }
}

export function prettifySize (size, separator =' ') {
  const sufixes = ['b', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(size) / Math.log(1024))
  return !size && ' ' || separator + (size / Math.pow(1024, i)).toFixed(0) + ' ' + sufixes[i]
}

function escapeHtml4 (string) {
  var matchHtmlRegExp = /["'&<>]/

  var str = '' + string
  var match = matchHtmlRegExp.exec(str)

  if (!match) {
    return str
  }

  var escape
  var html = ''
  var index = 0
  var lastIndex = 0

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34: // "
        escape = '&quot;'
        break
      case 38: // &
        escape = '&amp;'
        break
      case 39: // '
        escape = '&#39;'
        break
      case 60: // <
        escape = '&lt;'
        break
      case 62: // >
        escape = '&gt;'
        break
      default:
        continue
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index)
    }

    lastIndex = index + 1
    html += escape
  }

  return lastIndex !== index
    ? html + str.substring(lastIndex, index)
    : html
}

function escapeOpis (string) {
  var html = escapeHtml4(string)
  return html.replace(/(\r\n|\n)/g, '<br />').replace('  ', ' &emsp;')
}

export function trimOpis (string, len) {
  while (string.length > 0) {
    var escaped = escapeOpis(string)
    if (escaped.length > len) {
      string = string.substring(0, string.length - 1)
    } else {
      return string
    }
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/utils/index.js